"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var commonProperties_1 = require("./lib/commonProperties");
var event = function (_a) {
    var eventName = _a.eventName, endUserId = _a.endUserId, type = _a.type, platform = _a.platform, statsUrl = _a.statsUrl, getCookie = _a.getCookie, setCookie = _a.setCookie, payload = _a.payload, options = _a.options;
    var data = __assign(__assign({ EventName: eventName, Platform: platform, Type: type }, commonProperties_1.default(getCookie, setCookie)), payload);
    if (endUserId) {
        data.UserId = endUserId;
    }
    // we use fetch rather than axios because keepalive on axios just works in node
    return fetch(statsUrl + "/Event", {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(data),
        keepalive: options.keepAlive || false,
    });
};
exports.default = event;
//# sourceMappingURL=event.js.map